import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS, KEYS, STORAGE } from '../../_config';
import { StateExtended } from '../../_config/interfaces/stateExtended';

export const useAuthInitialization = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state: StateExtended) => state.user);

  useEffect(() => {
    // If not authenticated in Redux but have tokens in localStorage, restore auth state
    if (!isAuthenticated) {
      const userData = localStorage.getItem(STORAGE);
      const accessToken = localStorage.getItem(KEYS.AUTH_ACCESS);
      const refreshToken = localStorage.getItem(KEYS.AUTH_REFRESH);

      if (userData && accessToken && refreshToken) {
        try {
          const parsedUserData = JSON.parse(userData);
          dispatch({
            type: ACTIONS.USER.LOGIN,
            payload: {
              user: parsedUserData,
              accessToken: accessToken,
              refreshToken: refreshToken,
              isAuthenticated: true,
              permissions: true
            }
          });
        } catch (error) {
          console.error('Error parsing user data during auth initialization:', error);
          // Clear corrupted data
          localStorage.removeItem(STORAGE);
          localStorage.removeItem(KEYS.AUTH_ACCESS);
          localStorage.removeItem(KEYS.AUTH_REFRESH);
        }
      }
    }
  }, [dispatch, isAuthenticated]);
};